import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Tokenomics from './components/Tokenomics';
import Roadmap from './components/Roadmap';
import FooterBar from './components/FooterBar';
import Footer from './components/Footer';

function App() {

    return (
        <>
            <Navbar />
            <Hero />
            <About />
            <HowItWorks />
            <Tokenomics />
            <Roadmap />
            <FooterBar />
            <Footer />
        </>
    );

}

export default App;